import React, { memo, useCallback, useEffect, useState } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Box, Grid, TextField, Tooltip } from "@mui/material";
import { FormikProps, useFormikContext } from "formik";
import { Data } from "../../../../../store/terminal/types";
import { Mcc } from "../../../../../types";
import { Data as MerchantData } from "../../../../../store/merchant/types";
import AutocompleteField from "../../../../../common/formElements/AutocompleteField";
import { ApplicationState } from "../../../../../store";
import TextInput from "../../../../../common/formElements/TextInput";
import {fetchRequest } from "../../../../../store/merchant/actions";
import { search as searchRequest} from "../../../../../repo/merchant"
import { cloneDeep, debounce } from "lodash";
interface Props {
  isUpdateAllowed?: boolean;
}

const EditMerchantInfo = ({ isUpdateAllowed }: Props) => {
  const merchantState = useSelector(
    (state: ApplicationState) => state.merchant
  );
  const merchantOptions =
    // @ts-ignore.
    merchantState?.data?.data || ([] as MerchantData[]);
  const dispatch = useDispatch();
  const mcc = useSelector((state: ApplicationState) => state.mcc.data) ?? [];
  const filteredMcc = mcc.filter((x) => !x.mcc.startsWith("3"));
  const formikProps = useFormikContext();
  const { values, setFieldValue } = formikProps as FormikProps<Data>;
  const [merchantValue, setMerchantValue] = useState<MerchantData>()
  const nabMidIdx =
    values.attributes.Processor &&
    values.attributes.Processor.findIndex(
      (prc) =>
        prc.ProcessorName && prc.ProcessorName.toLowerCase().includes("nab")
    );
  const isNabMidAvalable = typeof nabMidIdx === "number" && nabMidIdx !== -1;

  const delayedSearch = useCallback(debounce(params => dispatch(fetchRequest(null, params)), 500), []);
  
  const p = {
    page: {
      limit: "10",
      offset: "0",
    },
    filter: {},
  };
  const searchMerchant = e => {
    if(e.target.value){
      p.filter["attributes.Name"] = e.target.value.trim();
    }
    delayedSearch(p)
  };

  const handleOnChange = (fieldName: string, value?: string | null) => {
    const temp = cloneDeep(merchantOptions).find(
          (m) => m.attributes.MID === value
        ) || null
        if(temp != null){
          setMerchantValue(temp)
        }
    setFieldValue(fieldName, value, false);
  };

  useEffect(() => {
    const pInitial = cloneDeep(p);
    pInitial.filter["attributes.MID"] = values.attributes.MID;
    searchRequest(null, pInitial).then((response) => {
      const responseData = response?.data?.[0]
      setMerchantValue(responseData)
    })
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={isNabMidAvalable ? 4 : 6}>
        {filteredMcc.length ? (
          <AutocompleteField
            fieldname="attributes.MCC"
            options={filteredMcc}
            value={mcc.find((c) => c.mcc === values.attributes.MCC)}
            onChange={(e, value: Mcc) =>
              handleOnChange("attributes.MCC", !isNil(value) ? value.mcc : "-")
            }
            getOptionLabel={(option): string =>
              `${option.mcc} - ${option.combined_description}`
            }
            renderOption={(props, option: Mcc) => (
              <div
                {...props}
              >{`${option.mcc} - ${option.combined_description}`}</div>
            )}
            renderInput={(params) => (
              <TextField {...params} label="MCC" variant="outlined" />
            )}
            disabled={!isUpdateAllowed}
          />
        ) : null}
      </Grid>

      <Grid item xs={12} md={isNabMidAvalable ? 4 : 6}>
      <Tooltip title="Type Merchant's name to search" arrow>
          <Autocomplete
            id="attributes.MID"
            options={cloneDeep(merchantOptions)}
            value={merchantValue || null}
            onChange={(e, value: MerchantData) =>
              handleOnChange(
                "attributes.MID",
                !isNil(value) ? value.attributes.MID : "-"
              )
            }
            getOptionLabel={(option): string => `${option.attributes?.Name}`}
            renderInput={(params) => (
              <TextField {...params} label="Merchant Name" variant="outlined" onChange={searchMerchant}/>
            )}
            disabled={!isUpdateAllowed}
          />
          </Tooltip>
      </Grid>

      {isNabMidAvalable ? (
        <Grid item xs={12} md={4}>
          <TextInput
            fieldname={`attributes.Processor[${nabMidIdx}].MID`}
            label="NAB MID"
            disabled
          />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default memo(EditMerchantInfo);
